class CafideSectionAnimator {
  constructor() {
    console.log('🎬 INIT: Cafide Cascade Animations');
    this.sections = [];
    this.isMobile = window.innerWidth < 768;
    this.section1Covered = false;
    this.initialized = false;
    this.init();
  }

  init() {
    // Escuchar eventos
    document.addEventListener('DOMContentLoaded', () => {
      console.log('✅ DOM loaded');
      this.scanAllSections();
      this.setupScrollAnimation();
      
      // Mostrar todas las secciones inmediatamente
      setTimeout(() => {
        this.showAllSections();
        this.calculatePositions();
        this.handleScroll();
        this.initialized = true;
      }, 50); // Muy rápido para evitar el parpadeo
    });

    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
      if (this.sections.length > 0) {
        this.calculatePositions();
        this.handleScroll();
      }
    });

    // Asegurar que se muestren cuando todo cargue
    window.addEventListener('load', () => {
      this.showAllSections();
      this.calculatePositions();
      this.handleScroll();
    });
  }

  // NUEVO: Mostrar todas las secciones inmediatamente
  showAllSections() {
    document.querySelectorAll('[data-cafide-animation="true"]').forEach(el => {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    });
    console.log('👁️ Todas las secciones visibles');
  }

  scanAllSections() {
    console.log('🔍 Scanning sections...');
    
    const triggers = document.querySelectorAll('[data-cafide-animation="true"]');
    console.log('🎯 Triggers found:', triggers.length);
    
    const sectionsArray = [];
    
    triggers.forEach(trigger => {
      const sectionId = trigger.dataset.sectionId;
      const role = trigger.dataset.cafideRole;
      const priority = parseInt(trigger.dataset.cafidePriority) || 1;
      const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
      
      if (sectionElement) {
        sectionsArray.push({
          element: sectionElement,
          id: sectionId,
          role: role,
          priority: priority,
          originalTop: 0,
          height: 0,
          maxTranslate: 0,
          isPinned: false,
          isLast: false,
          isFirst: priority === 1
        });
        console.log(`  → Section ${priority}: ${role}`);
      }
    });
    
    // Sort by priority (lower number = higher on page)
    this.sections = sectionsArray.sort((a, b) => a.priority - b.priority);
    
    // Mark first and last sections
    if (this.sections.length > 0) {
      this.sections[this.sections.length - 1].isLast = true;
      this.sections[0].isFirst = true;
      console.log(`📌 FIRST SECTION: priority ${this.sections[0].priority}`);
      console.log(`📌 LAST SECTION: priority ${this.sections[this.sections.length - 1].priority}`);
    }
    
    // Calculate positions after a small delay
    setTimeout(() => this.calculatePositions(), 200);
    
    // Apply initial styles
    this.applyInitialStyles();
  }

  calculatePositions() {
    const viewportHeight = window.innerHeight;
    let cumulativeTop = 0;
    
    this.sections.forEach((section, index) => {
      const rect = section.element.getBoundingClientRect();
      section.height = rect.height;
      section.originalTop = cumulativeTop;
      
      // Calculate how much this section can move up
      if (section.height > viewportHeight) {
        // Sections taller than viewport
        section.maxTranslate = -(section.height - viewportHeight);
      } else {
        // Sections shorter than viewport
        section.maxTranslate = -section.height;
      }
      
      // Last section has limited movement
      if (section.isLast) {
        section.maxTranslate = Math.max(section.maxTranslate, -100);
        console.log(`  🚫 Last section movement limited to ${section.maxTranslate}px`);
      }
      
      console.log(`  Section ${index + 1}: height=${section.height}px, maxTranslate=${section.maxTranslate}px, top=${section.originalTop}px ${section.isLast ? '(LAST)' : ''} ${section.isFirst ? '(FIRST)' : ''}`);
      
      cumulativeTop += rect.height;
    });
  }

  applyInitialStyles() {
    this.sections.forEach((section, index) => {
      const el = section.element;
      
      // Asegurar que sean visibles
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      
      // First section starts as sticky (but can change)
      if (index === 0) {
        el.style.position = 'sticky';
        el.style.top = '0';
        el.style.zIndex = '1';
        el.classList.add('cafide-bg-section');
        el.classList.remove('cafide-overlay-section');
      } else {
        // Others start as overlay
        el.style.position = 'relative';
        el.style.top = 'auto';
        el.style.zIndex = String(this.sections.length - index);
        el.style.backgroundColor = 'white';
        el.classList.add('cafide-overlay-section');
        el.classList.remove('cafide-bg-section');
      }
      
      el.style.willChange = 'transform';
    });
  }

  setupScrollAnimation() {
    if (this.sections.length < 2) return;
    
    console.log('🔄 Setting up cascade animation...');
    
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    
    // Initial trigger
    this.handleScroll();
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    
    // Different thresholds for mobile vs desktop
    const stickyThreshold = this.isMobile ? 0.7 : 0.99;
    const coverThreshold = this.isMobile ? 0.8 : 0.4;
    
    // Process each section starting from the second one
    for (let i = 1; i < this.sections.length; i++) {
      const currentSection = this.sections[i];
      const prevSection = this.sections[i - 1];
      
      if (!currentSection.element || !prevSection.element) continue;
      
      const prevBottom = prevSection.originalTop + prevSection.height;
      const currentTop = currentSection.originalTop;
      
      // Point where current section STARTS entering
      const startPoint = currentTop - viewportHeight;
      
      // Point where current section SHOULD STOP moving
      const endPoint = prevBottom - currentSection.maxTranslate;
      
      // Calculate progress
      let progress = 0;
      
      if (scrollY > startPoint) {
        if (scrollY < endPoint) {
          // In the middle of animation
          progress = Math.min(1, Math.max(0, (scrollY - startPoint) / (endPoint - startPoint)));
        } else {
          // Reached final position
          progress = 1;
        }
      }
      
      // Calculate how much to move up based on progress
      const translateY = progress * currentSection.maxTranslate;
      
      // Apply transform
      if (progress > 0) {
        currentSection.element.style.transform = `translateY(${translateY}px)`;
        
        // When reached final position (using mobile-adjusted threshold)
        if (progress >= stickyThreshold) {
          currentSection.element.classList.add('is-covering');
          currentSection.isPinned = true;
          
          // Convert current section to background (sticky) if not last
          if (!currentSection.isLast) {
            currentSection.element.style.position = 'sticky';
            currentSection.element.style.top = '0';
            currentSection.element.style.zIndex = String(i + 1);
            currentSection.element.classList.remove('cafide-overlay-section');
            currentSection.element.classList.add('cafide-bg-section');
          }
          
          // If last section and fully covered
          if (currentSection.isLast && progress >= 0.99) {
            // Hide intermediate sections (2 and 3)
            for (let j = 1; j < i; j++) {
              const sectionToHide = this.sections[j];
              if (sectionToHide) {
                sectionToHide.element.style.opacity = '0';
                sectionToHide.element.style.pointerEvents = 'none';
                sectionToHide.element.style.visibility = 'hidden';
              }
            }
          }
          
          // Dim the previous section (but not section 1 if it's the previous one)
          if (i > 1) {
            prevSection.element.style.opacity = '0.3';
          }
        } else {
          currentSection.element.classList.remove('is-covering');
          currentSection.isPinned = false;
          
          // Restore visibility of hidden sections
          for (let j = 1; j < this.sections.length; j++) {
            const sectionToShow = this.sections[j];
            if (sectionToShow && sectionToShow.element.style.visibility === 'hidden') {
              sectionToShow.element.style.opacity = '1';
              sectionToShow.element.style.pointerEvents = 'auto';
              sectionToShow.element.style.visibility = 'visible';
            }
          }
          
          // Restore previous section opacity
          if (i > 1) {
            prevSection.element.style.opacity = '1';
          }
        }
      } else {
        // No progress - reset styles
        currentSection.element.style.transform = '';
        currentSection.element.classList.remove('is-covering');
        if (i > 1) {
          prevSection.element.style.opacity = '1';
        }
      }
      
      // SECTION 1 MANAGEMENT: Change from sticky to relative when section 2 covers it
      if (i === 1) { // Only for section 2
        const section1 = this.sections[0];
        const section2 = this.sections[1];
        
        if (section1 && section2) {
          // Calculate how much section 2 has covered section 1
          const coverProgress = progress;
          
          if (coverProgress >= coverThreshold && !this.section1Covered) {
            this.section1Covered = true;
            // Change section 1 from sticky to relative
            section1.element.style.position = 'relative';
            section1.element.style.top = 'auto';
            console.log('🎯 Section 1 covered by section 2 - changed to relative');
          } 
          else if (coverProgress < coverThreshold && this.section1Covered) {
            this.section1Covered = false;
            section1.element.style.position = 'sticky';
            section1.element.style.top = '0';
            console.log('↩️ Section 1 uncovered - restored to sticky');
          }
        }
      }
    }
    
    // Ensure section 1 is always visible
    if (this.sections[0]) {
      const firstSection = this.sections[0].element;
      firstSection.style.opacity = '1';
      firstSection.style.visibility = 'visible';
    }
  }
}

// Initialize the system
window.CafideAnimations = new CafideSectionAnimator();
